<div class="log-in-container text-center">
  <lds-ng-lw-data-studio [hidden]="!loading"></lds-ng-lw-data-studio>
  <form class="form-signin" (ngSubmit)="user.action()">

    <img class="lw-logo medium" src="../../assets/icons/logo-icon-green.png" alt="">
    <h1 class="h3 mb-3 font-weight-normal reduce-top-margin">
      My Lightwave Energy Dashboard
    </h1>
    <label for="inputEmail" class="sr-only">Admin Address</label>
    <input type="email" id="inputAdminEmail" name="AdminUsername" [(ngModel)]="user.adminEmail" class="form-control" placeholder="Admin email" required autofocus [disabled]="mfaRequired">
    <label for="inputEmail" class="sr-only">Email Address</label>
    <input type="email" id="inputEmail" name="Username" [(ngModel)]="user.username" class="form-control" placeholder="Email address" required [disabled]="mfaRequired">
    <label for="inputPassword" class="sr-only">Password</label>
    <input type="password" id="inputPassword" name="Password" [(ngModel)]="user.password" class="form-control" placeholder="Password" required [disabled]="mfaRequired">
    @if (mfaRequired) {
      <div class="mfa-input-container">
        <label for="inputMfaCode" class="sr-only">Authentication Code</label>
        <input type="text" id="inputMfaCode" name="MfaCode" [(ngModel)]="mfaCode" class="form-control" placeholder="6-digit code" maxlength="6" pattern="[0-9]{6}" required autofocus>
      </div>
    }
    <button type="submit" name="button" class="lw-gradient-text lw-main-btn btn btn-lg btn-primary btn-block">{{ mfaRequired ? 'Verify' : 'Sign in' }}</button>
    @if (message) {
      <div class="alert alert-danger" role="alert">
        <div>{{message}}</div>
      </div>
    }
    <p class="mt-2 mb-3 text-muted">© 2022</p>
  </form>
</div>
